<template>
    <div class="col-12 form-group">
        <page-header :title="title" :items="items" />
        <b-card
            bg-variant="light"
            header="Select a city"
            header-class="card-header  p-3 h5"
            header-text-variant="black"
            header-tag="header"
        >
            <div>
                <vue-typeahead-bootstrap
                    v-model="hCalculationData.city"
                    :show-on-focus="true"
                    :min-matching-chars="0"
                    :max-matches="25"
                    :data="searchResult"
                    :serializer="
                        item =>
                            item.nameInHebrew
                                ? `${item.nameInHebrew} - climate ${item.climate}`
                                : ''
                    "
                    placeholder="Type name of the city in Hebrew that you want to choose"
                    @hit="hCalculationData.climate = $event.climate"
                    @input="fetchCities({ q: hCalculationData.city })"
                />
            </div>
        </b-card>
        <br />
        <b-card-group deck>
            <b-card
                bg-variant="light"
                header="Select mass per unit area of exterior walls (kg / m²)"
                header-class="card-header  p-3 h5"
                header-text-variant="black"
                header-tag="header"
            >
                <div>
                    <v-select
                        v-model="hCalculationData.massPerUnit"
                        item-value="key"
                        item-text="label"
                        :options="selectOptions"
                        :menu-props="{ top: true, offsetY: true }"
                        class="mb-2"
                        style="width: 100%"
                        placeholder="Select mass per unit"
                    />
                </div>
            </b-card>
            <b-card
                bg-variant="light"
                header=" Email Address"
                header-class="card-header  p-3 h5"
                header-text-variant="black"
                header-tag="header"
            >
                <div class="d-flex form-group justify-content-center row-2">
                    <input
                        v-model="hCalculationData.email"
                        type="text"
                        class="form-control"
                        dir="auto"
                        placeholder="Type email address where pdf would be sent"
                    />
                </div>
            </b-card>
        </b-card-group>
        <br />
        <b-card-group deck>
            <b-card
                bg-variant="light"
                header="Percentage of wall bridge"
                header-class="card-header  p-3 h5"
                header-text-variant="black"
                header-tag="header"
            >
                <div class="d-flex form-group justify-content-center row-2">
                    <b-input-group>
                        <b-form-input
                            v-model="hCalculationData.wallBridgePercentage"
                            :value="+'%'"
                            type="text"
                            class="form-control"
                            dir="auto"
                        />
                        <b-input-group-text
                            class="md-suffix bg-transparent border-left-0"
                        >
                            %
                        </b-input-group-text>
                    </b-input-group>
                </div>
            </b-card>
            <b-card
                bg-variant="light"
                header="U-Value of wall bridge"
                header-class="card-header  p-3 h5"
                header-text-variant="black"
                header-tag="header"
            >
                <div class="d-flex form-group justify-content-center row-2">
                    <input
                        v-model="hCalculationData.uValueOfWallBridge"
                        type="text"
                        class="form-control"
                        dir="auto"
                    />
                </div>
            </b-card>
        </b-card-group>

        <br />
        <h-calculation-dropzone :h-calculation-data="hCalculationData" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import vueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

import hCalculationDropzone from '@/components/file/HCalculationDropzone';

export default {
    page: {
        title: 'Greener: H-Calculations'
    },

    components: {
        hCalculationDropzone,
        vueTypeaheadBootstrap
    },

    data() {
        return {
            hCalculationData: {
                city: '',
                email: '',
                massPerUnit: null,
                wallBridgePercentage: 10,
                uValueOfWallBridge: 2
            },
            searchResult: [],
            cities: [],
            selectOptions: [
                { key: '110', label: '> 100' },
                { key: '90', label: '< 100' }
            ],
            title: 'H-Calculations',
            items: [
                {
                    text: 'Greener',
                    to: '/'
                },
                {
                    text: 'H-Calculations',
                    active: true
                }
            ]
        };
    },

    async created() {
        await this.fetchCities();
    },

    methods: {
        ...mapActions({
            getCities: 'cities/index'
        }),

        async fetchCities(searchParams) {
            try {
                this.cities = await this.getCities({
                    searchParams
                });

                this.searchResult = this.cities;
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>

<style>
.verticalLine {
    border-left: thick solid #ff0000;
    height: 100%;
}
</style>
